.wrapper {
  position: relative;
}

.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  min-height: 40px;
  outline: none;
  padding: 4px 12px;
  transition: border-color 0.15s;
  width: 100%;

  &:hover {
    border-color: var(--color-foreground);
  }
}

.root-size-sm {
  font-size: 13px;
  min-height: 32px;
}

.root-is-open {
  border-color: var(--color-foreground);
}

.root-is-disabled {
  background: var(--color-secondary);
  cursor: not-allowed;
  opacity: 0.6;
}

.placeholder {
  color: var(--color-placeholder);
  flex: 1;
  text-align: left;
}

.pills {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
  padding: 2px 0;
}

.pill {
  align-items: center;
  background: var(--color-secondary);
  border: 1px solid var(--color-border);
  border-radius: 9999px;
  color: var(--color-foreground);
  display: inline-flex;
  font-size: 13px;
  font-weight: 500;
  gap: 4px;
  max-width: 100%;
  padding: 1px 6px 1px 10px;
}

.pill-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pill-remove {
  color: var(--color-muted);
  cursor: pointer;
  flex-shrink: 0;
  height: 14px;
  transition: color 0.15s;
  width: 14px;

  &:hover {
    color: var(--color-foreground);
  }
}

.clearAll {
  color: var(--color-muted);
  cursor: pointer;
  flex-shrink: 0;
  height: 16px;
  transition: color 0.15s;
  width: 16px;

  &:hover {
    color: var(--color-foreground);
  }
}

.chevron {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  transition: transform 0.15s;
  width: 14px;
}

.chevron-open {
  transform: rotate(180deg);
}

/* --- Dropdown --- */

.dropdown {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  left: 0;
  max-height: 320px;
  max-width: min(320px, calc(100vw - 24px));
  min-width: 100%;
  overflow: hidden;
  padding: 4px;
  position: absolute;
  top: calc(100% + 4px);
  width: max-content;
  z-index: 50;
}

.searchRow {
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  gap: 6px;
  margin: -4px -4px 4px;
  padding: 8px 10px;
}

.searchIcon {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}

.searchInput {
  background: transparent;
  border: none;
  color: var(--color-foreground);
  flex: 1;
  font-family: inherit;
  font-size: 14px;
  outline: none;
  padding: 0;

  &::placeholder {
    color: var(--color-placeholder);
  }
}

.optionList {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.option {
  align-items: center;
  background: none;
  border: none;
  border-radius: 4px;
  color: var(--color-foreground);
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 14px;
  gap: 8px;
  padding: 6px 8px;
  text-align: left;
  transition: background-color 0.1s;
  width: 100%;

  &:hover {
    background: var(--color-secondary);
  }
}

.option-create {
  color: var(--color-focus);
}

.create-icon {
  flex-shrink: 0;
  height: 16px;
  width: 16px;
}

.optionLabel {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal;
  word-break: break-word;
}

.checkbox {
  align-items: center;
  background: var(--color-background);
  border: 1.5px solid var(--color-focus);
  border-radius: 4px;
  display: inline-flex;
  flex-shrink: 0;
  height: 16px;
  justify-content: center;
  opacity: 0.5;
  width: 16px;
}

.checkbox-checked {
  background: var(--color-focus);
  border-color: var(--color-focus);
  opacity: 1;
}

.checkIcon {
  color: var(--color-background);
  height: 12px;
  stroke-width: 3;
  width: 12px;
}

.empty {
  color: var(--color-muted);
  display: block;
  font-size: 13px;
  padding: 12px;
  text-align: center;
}

.dropdown-portal {
  left: auto;
  right: auto;
  top: auto;
  z-index: 2100;
}
